
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormContainer } from "../../Components/FormContainer.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Input } from "../../Components/Input.js";
import { Msg } from "./Types.js";
import { defaultArgWith, map as map_1, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormState__getValidation } from "../../Shared/Shared.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { BusinessUnitSelect } from "../../Widgets/BusinessUnitSelect.js";
import { Select } from "../../Components/Select.js";
import { singleton as singleton_1, append as append_1, ofArray, tryFind, map, sortBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Hierarchy_getPath } from "../../Shared/Location.js";
import { equals, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { NewReceiverCustomProperties } from "../../Widgets/CustomProperties.js";
import { PropertyConfigurationVisibility } from "../../Shared/PropertyConfiguration.js";
import { Table_UserVisibleTable } from "../UserSelect.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEdit, update as update_1, initNew } from "./State.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { getQueryParams } from "../../Common.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function RoomFormContent(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(FormContainer, {
        Children: toList(delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("room.name"),
            OnChange: (arg) => {
                props.Dispatch(new Msg(0, [arg]));
            },
            TestId: "room-name",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
            Value: props.Room.Name,
        })), delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("room.number"),
            OnChange: (arg_1) => {
                props.Dispatch(new Msg(1, [arg_1]));
            },
            TestId: "room-number",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "number")),
            Value: props.Room.Number,
        })), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton(createElement(BusinessUnitSelect, {
            BusinessUnits: props.BusinessUnits,
            FormState: props.FormState,
            OnChange: (value) => {
                props.Dispatch(new Msg(5, [value]));
            },
            SelectedBusinessUnitId: unwrap(props.Room.BusinessUnitId),
        })) : empty()) : empty(), delay(() => {
            let Label_2, Value_2;
            return append(isFeatureEnabled(new Feature(15, [])) ? singleton(createElement(Input, (Label_2 = t("general.email"), (Value_2 = defaultArg(props.Room.Email, ""), {
                ComponentState: componentState,
                Label: unwrap(Label_2),
                OnChange: (arg_2) => {
                    props.Dispatch(new Msg(2, [arg_2]));
                },
                TestId: "room-email",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "email")),
                Value: Value_2,
            })))) : empty(), delay(() => {
                let Label_3, Options, Value_3;
                return append(singleton(createElement(Select, (Label_3 = t("room.location"), (Options = sortBy((_arg) => _arg.label, map((location) => ({
                    label: Hierarchy_getPath(props.Locations, location),
                    value: location.Id,
                }), props.Locations), {
                    Compare: (x, y) => (comparePrimitives(x, y) | 0),
                }), (Value_3 = map_1((location_2) => ({
                    label: Hierarchy_getPath(props.Locations, location_2),
                    value: location_2.Id,
                }), tryFind((location_1) => equals(location_1.Id, props.Room.LocationId), props.Locations)), {
                    ComponentState: componentState,
                    IsClearable: false,
                    Label: unwrap(Label_3),
                    NoOptionsMessage: "",
                    OnChange: (option_1) => {
                        props.Dispatch(new Msg(3, [map_1((_arg_1) => _arg_1.value, option_1)]));
                    },
                    Options: Options,
                    PlaceholderKey: "",
                    TestId: "room-location",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "location")),
                    Value: unwrap(Value_3),
                }))))), delay(() => append(props.IsCustomPropertiesEnabled ? singleton(createElement(NewReceiverCustomProperties, {
                    Currency: props.CustomerConfiguration.Currency,
                    CustomProperties: props.Room.CustomProperties,
                    FormState: props.FormState,
                    OnSetCustomProperty: (arg_3) => {
                        props.Dispatch(new Msg(4, [arg_3]));
                    },
                    PropertyConfigurationType: new PropertyConfigurationVisibility(6, []),
                    PropertyConfigurations: props.PropertyConfigurations,
                })) : empty(), delay(() => singleton(createElement(Table_UserVisibleTable, {
                    CustomerConfiguration: props.CustomerConfiguration,
                    IsOpen: props.VisibleUserModalIsOpen,
                    OnClose: () => {
                        props.Dispatch(new Msg(10, []));
                    },
                    OnDelete: props.OnDeleteVisibleUserIds,
                    OnSave: props.OnSaveVisibleUserIds,
                    PropertyConfigurations: props.PropertyConfigurations,
                    SetIsOpen: () => {
                        props.Dispatch(new Msg(10, []));
                    },
                    Users: props.Users,
                    VisibleForUserIds: props.Room.VisibleForUserIds,
                }))))));
            }));
        })))))))),
        FormState: props.FormState,
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function NewRoomView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNew, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.Locations;
    const matchValue_2 = state_1.IsCustomPropertiesEnabled;
    const matchValue_3 = state_1.PropertyConfigurations;
    const matchValue_4 = state_1.Users;
    const matchValue_5 = state_1.AccountSettings;
    const matchValue_6 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, isCustomPropertiesEnabled, locations, propertyConfigurations, room, users;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_5.fields[0];
        businessUnits = matchValue_6.fields[0];
        isCustomPropertiesEnabled = matchValue_2.fields[0];
        locations = matchValue_1.fields[0];
        propertyConfigurations = matchValue_3.fields[0];
        room = matchValue.fields[0];
        users = matchValue_4.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(RoomFormContent, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("room.create_new_room"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                Locations: locations,
                OnBack: () => {
                    RouterModule_nav(ofArray(["receivers", "rooms" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                },
                OnDeleteVisibleUserIds: (userIds_1) => {
                    dispatch(new Msg(12, [userIds_1]));
                },
                OnSave: () => {
                    dispatch(new Msg(6, []));
                },
                OnSaveVisibleUserIds: (userIds) => {
                    dispatch(new Msg(11, [userIds]));
                },
                PropertyConfigurations: propertyConfigurations,
                Room: room,
                Users: users,
                VisibleUserModalIsOpen: state_1.VisibleUserModalIsOpen,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function EditRoomView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEdit, update_1, (_arg, _arg_1) => {
    }), props.RoomId, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.Locations;
    const matchValue_2 = state_1.IsCustomPropertiesEnabled;
    const matchValue_3 = state_1.PropertyConfigurations;
    const matchValue_4 = state_1.Users;
    const matchValue_5 = state_1.AccountSettings;
    const matchValue_6 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, isCustomPropertiesEnabled, locations, propertyConfigurations, room, users;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_5.fields[0];
        businessUnits = matchValue_6.fields[0];
        isCustomPropertiesEnabled = matchValue_2.fields[0];
        locations = matchValue_1.fields[0];
        propertyConfigurations = matchValue_3.fields[0];
        room = matchValue.fields[0];
        users = matchValue_4.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(RoomFormContent, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("room.edit_room"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                Locations: locations,
                OnBack: () => {
                    const xs = ofArray(props.OnBackPath);
                    const queryString = getQueryParams(undefined);
                    defaultArgWith(map_1((tupledArg) => {
                        RouterModule_nav(append_1(tupledArg[0], singleton_1(tupledArg[1] + RouterModule_encodeQueryString(queryString))), 1, 1);
                    }, RouterModule_trySeparateLast(xs)), () => {
                        RouterModule_nav(singleton_1(RouterModule_encodeQueryString(queryString)), 1, 1);
                    });
                },
                OnDeleteVisibleUserIds: (userIds_1) => {
                    dispatch(new Msg(12, [userIds_1]));
                },
                OnSave: () => {
                    dispatch(new Msg(7, []));
                },
                OnSaveVisibleUserIds: (userIds) => {
                    dispatch(new Msg(11, [userIds]));
                },
                PropertyConfigurations: propertyConfigurations,
                Room: room,
                Users: users,
                VisibleUserModalIsOpen: state_1.VisibleUserModalIsOpen,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

